function isTokenOrderPickupRoute(route) {
  if (!route || typeof route.name !== "string" || !route.name) {
    return false;
  }

  const name = route.name;
  const isOrderPage = name === "orders-order" || name.startsWith("orders-order___");
  if (!isOrderPage) {
    return false;
  }

  const token = route.query && route.query.token;
  return typeof token === "string" && token !== "";
}

module.exports = { isTokenOrderPickupRoute };
